import * as React from "react"
import { Col, Container, Row } from "react-grid-system"
import Card from "../../atoms/Card"
import Subtitle from "../../atoms/typography/Subtitle"
import { HorizontalSpacer } from "../../atoms/spacers"
import TextInput from "../../molecules/TextInput"
import SecondaryButton from "../../atoms/buttons/SecondaryButton"

import { useResetPasswordConfirm } from "../../../hooks/useResetPasswordConfirm"
import BodyMedium from "../../atoms/typography/BodyMedium"
import { theme } from "../../theme"
import Body from "../../atoms/typography/Body"

const ResetPasswordPage: React.FC = () => {
  React.useEffect(() => {
    document.title = "Reset password"
  }, [])

  const [password1, setPassword1] = React.useState("")
  const [password2, setPassword2] = React.useState("")

  const onCompletedResetPassword = () => {
    console.log("successfully called reset password")

    if (data?.passwordResetConfirm?.errors?.length > 0) {
      console.log("there was an error updating the password")
    } else {
      // redirect to reset done page
      window.location.href = "/reset/done"
    }
  }
  const onErrorResetPassword = () => {
    // print error message
    console.log("error: ", data)
  }

  const { resetPasswordConfirm, data, loading } = useResetPasswordConfirm({
    onCompleted: onCompletedResetPassword,
    onError: onErrorResetPassword,
  })

  const onResetPasswordConfirm = async (event: any) => {
    event.preventDefault()

    try {
      await resetPasswordConfirm({
        variables: {
          uid: window.location.href.split("/")[4],
          token: window.location.href.split("/")[5],
          password1: password1,
          password2: password2,
        },
      })
    } catch (error) {
      console.log("error: ", error)
    }
  }

  return (
    <div style={{ backgroundColor: "#D5E2EAe1", minHeight: "100vh" }}>
      <HorizontalSpacer spacing={6} />
      <Container>
        <Row justify="center">
          <Col md={3} xs={0} />
          <Col md={6} xs={12}>
            <Card>
              <form onSubmit={(e) => onResetPasswordConfirm(e)}>
                <HorizontalSpacer spacing={2} />
                <Row justify="center">
                  <Subtitle>Choose new password</Subtitle>
                </Row>
                <HorizontalSpacer spacing={4} />
                <Row justify="center">
                  <TextInput
                    textFieldTitle="New password"
                    name="password1"
                    onChange={(e) => setPassword1(e.target.value)}
                    type="password"
                    required
                    tabIndex={5}
                  />
                </Row>
                <HorizontalSpacer spacing={3} />
                <Row justify="center">
                  <TextInput
                    textFieldTitle="Password"
                    name="password2"
                    onChange={(e) => setPassword2(e.target.value)}
                    type="password"
                    inputAccepted={password2.length > 0 && password1 === password2}
                    required
                    tabIndex={6}
                  />
                </Row>
                <HorizontalSpacer spacing={3} />
                <div>
                  {data?.passwordResetConfirm?.errors?.length > 0 && (
                    <>
                      <BodyMedium color={theme.colors.red} textAlign="center">
                        {data?.passwordResetConfirm?.errors[0]}
                      </BodyMedium>
                      <HorizontalSpacer spacing={1} />
                    </>
                  )}
                </div>
                <Row justify="center">
                  <Col md={8}>
                    <Body>▪️ Your password can’t be too similar to your other personal information.</Body>
                    <Body>▪️ Your password must contain at least 8 characters.</Body>
                    <Body>▪️ Your password can’t be a commonly used password.</Body>
                    <Body>▪️ Your password can’t be entirely numeric.</Body>
                  </Col>
                </Row>

                <HorizontalSpacer spacing={3} />
                <Row justify="center">
                  <SecondaryButton title="Update password" type="submit" />
                </Row>
                <HorizontalSpacer spacing={2} />
              </form>
            </Card>
          </Col>
          <Col md={3} xs={0} />
        </Row>
      </Container>
      <HorizontalSpacer spacing={3} />
    </div>
  )
}

export default ResetPasswordPage
